import { useId } from "react";

interface SparklesGradientIconProps {
  size?: number;
  style?: React.CSSProperties;
}

const SparklesGradientIcon = ({ size = 16, style }: SparklesGradientIconProps) => {
  const id = useId();
  const gradId = `sg-${id}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", flexShrink: 0, ...style }}
    >
      <defs>
        <linearGradient
          id={gradId}
          x1="4.42"
          y1="21.30"
          x2="19.58"
          y2="2.70"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="13.95%" stopColor="#7DCBC1" />
          <stop offset="46.68%" stopColor="#3A8CC4" />
          <stop offset="68.41%" stopColor="#FF5E00" />
        </linearGradient>
      </defs>
      <path
        d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"
        stroke={`url(#${gradId})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M20 3v4" stroke={`url(#${gradId})`} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22 5h-4" stroke={`url(#${gradId})`} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 17v2" stroke={`url(#${gradId})`} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5 18H3" stroke={`url(#${gradId})`} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default SparklesGradientIcon;
